import React from "react";

import { Container, Row, Col, Spinner } from "react-bootstrap";
import { isMobile } from "react-device-detect";

import { crearEstacionesState } from "../inumet_js_lib/model/estaciones/estacionesState";
import FiltroEstaciones from "../inumet_js_lib/model/estaciones/filtrosEstaciones";
import OrdenEstaciones, {
    TIPO_ORDEN_ESTACIONES_GERENCIA_TIPOESTACION_NOMBRE,
} from "../inumet_js_lib/model/estaciones/ordenEstaciones";
import MetConstants from "../inumet_js_lib/model/datosVars/metConstants";
import { DATE_TIME_LATIN_FORMAT } from "../inumet_js_lib/utils/dateUtils";
import { TRISTATE_CUALQUIERA } from "../inumet_js_lib/utils/triStateUtils";
import DatosVarsUI from "../inumet_js_lib/model/datosVars/datosVarsUI";
import DatosVars from "../inumet_js_lib/model/datosVars/datosVars";
import { getEscalasVars } from "../inumet_js_lib/model/escalas/escalasVars";
import axios from "axios";
import Logo from "../components/inumet/logo/LogoM";
import ImgButton from "../components/buttons/imgButton";
import FAIcon from "../components/icons/faIcon";
import Colors from "../res/colors/colors";
import RadioGroup, { RadioItemData } from "../components/controls/radioGroup";
import MapaDatosVars from "../components/datos_vars/mapaDatosVars";
import SpinnerFechasDatosVars from "../components/datos_vars/spinnerFechasDatosVars";

import "./monitoreoDatosVarsMapa.css";

const TEST = 0;
const VERSION = 2;
const PROD_URL_DATOS =
    "https://www.inumet.gub.uy/reportes/estadoActual/datos_inumet_ui_publica.mch";
const TEST_URL_DATOS = "http://localhost:3000/datos_inumet_ui_publica.mch";
const TEST_ASSETS_URL = "/assets/img/";
const PROD_ASSETS_URL = "/reportes/pages/datos24hv2/assets/img/";
let SPLASH_TIMEOUT = 3000;

const IDS_VARS_FICHAS_ESTACIONES = [
    MetConstants.VAR_ID_TEMPAIRE_1H_INST,
    MetConstants.VAR_ID_TEMPPTOROCIO_1H_INST,
    MetConstants.VAR_ID_PRECIP_1H_ACUM,
    MetConstants.VAR_ID_HUMRELATIVA_1H_INST,
    MetConstants.VAR_ID_PRESATMMAR_1H_INST,
    MetConstants.VAR_ID_PRECIPR3_24H_ACUM,
    MetConstants.VAR_ID_INTVIENTO_1H_MAX,
];
const IDS_VARS_ESCALAS = [
    MetConstants.VAR_ID_DIRVIENTO_1H_INST,
    MetConstants.VAR_ID_INTVIENTO_1H_INST,
    MetConstants.VAR_ID_INTVIENTO_1H_MAX,
    MetConstants.VAR_ID_TEMPAIRE_1H_INST,
    MetConstants.VAR_ID_PRECIP_1H_ACUM,
    MetConstants.VAR_ID_HUMRELATIVA_1H_INST,
    MetConstants.VAR_ID_PRESATMMAR_1H_INST,
    MetConstants.VAR_ID_VISIBILIDAD,
    MetConstants.VAR_ID_INTRAFAGA_1H_INST,
    MetConstants.VAR_ID_TEMPPTOROCIO_1H_INST,
    MetConstants.VAR_ID_PRECIPR3_24H_ACUM,
];

const CENTRO_MAPA_INICIAL = {
    latitud: -32.87667,
    longitud: -55.8,
};

let intervalPlayId = 0;
let intervalRefreshId = 0;

const PLAY_TIME = 700;

class ItemMenuSpec {
    constructor(label, order, sublabel) {
        this.label = label;
        this.order = order;
        this.sublabel = sublabel;
    }
}

let varsOpciones = {};
varsOpciones[MetConstants.VAR_ID_TEMPAIRE_1H_INST] = new ItemMenuSpec(
    "Temp. Aire (°C)",
    0
);
varsOpciones[MetConstants.VAR_ID_HUMRELATIVA_1H_INST] = new ItemMenuSpec(
    "Humedad Relativa(%)",
    1
);
varsOpciones[MetConstants.VAR_ID_TEMPPTOROCIO_1H_INST] = new ItemMenuSpec(
    "Temp. Pto. Rocío (°C)",
    2
);
varsOpciones[MetConstants.VAR_ID_PRESATMMAR_1H_INST] = new ItemMenuSpec(
    "Pres. Atm. Mar (hpa)",
    3
);
varsOpciones[MetConstants.VAR_ID_PRECIP_1H_ACUM] = new ItemMenuSpec(
    "Precip. Horaria (mm)",
    4,
    "Solo disponible en automáticas"
);
varsOpciones[MetConstants.VAR_ID_PRECIPR3_24H_ACUM] = new ItemMenuSpec(
    "Precip. Diaria (mm)",
    5,
    "Tomada de 7AM a 7AM"
);
varsOpciones[MetConstants.VAR_ID_VISIBILIDAD] = new ItemMenuSpec(
    "Visibilidad (km)",
    6
);
varsOpciones[MetConstants.VAR_ID_INTVIENTO_1H_INST] = new ItemMenuSpec(
    "Viento (km/h)",
    7
);

const GERENCIAS_DEFAULT = [
    MetConstants.gerencias.inumet,
    MetConstants.gerencias.inmet,
    MetConstants.gerencias.smn,
    MetConstants.gerencias.inia,
    MetConstants.gerencias.caisa,

];

class MonitoreoDatosVarsMapa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isError: false,
            datosVars: null,
            cantHorasConsultadas: 0,
            centroMapaInicial: CENTRO_MAPA_INICIAL,
            gerencias: GERENCIAS_DEFAULT,
            automaticas: TRISTATE_CUALQUIERA,
            convencionales: TRISTATE_CUALQUIERA,
            idVariable: MetConstants.VAR_ID_TEMPAIRE_1H_INST,
            iFecha: 0,
            playing: false,
            iPlay: 0,
            showingSplash: true,
            isOpenMenu: false,
            isHidden: !document.hidden,
        };
        this.consultarDatos = this.consultarDatos.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
        this.onVarChange = this.onVarChange.bind(this);
        this.onDateTimeChange = this.onDateTimeChange.bind(this);
        this.onStepBw = this.onStepBw.bind(this);
        this.onPlay = this.onPlay.bind(this);
        this.onStepFw = this.onStepFw.bind(this);
        this.playDateTime = this.playDateTime.bind(this);
        this.setFiltroEstaciones = this.setFiltroEstaciones.bind(this);
        this.onIFechaChange = this.onIFechaChange.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

        this.graficasVariablesCombinadas = {};
        let tempsVars = {
            idsVars: [
                MetConstants.VAR_ID_TEMPAIRE_1H_INST,
                MetConstants.VAR_ID_TEMPPTOROCIO_1H_INST,
            ],
            label: "Temp.Aire/Temp.Pto.Rocío (ºC)",
        };

        this.graficasVariablesCombinadas[MetConstants.VAR_ID_TEMPAIRE_1H_INST] =
            tempsVars;

        this.botonMenuOpcionesRef = React.createRef();
        this.botonReferenciasRef = React.createRef();
        if (TEST === 1) SPLASH_TIMEOUT = 300;
    }

    onIFechaChange(iFecha) {
        if (iFecha >= this.state.cantFechasVar) iFecha = 0;
        else if (iFecha < 0) iFecha = this.state.cantFechasVar - 1;
        this.setState({ iFecha });
    }

    playDateTime() {
        this.setState((prevState) => {
            let newiFecha =
                prevState.iFecha < this.state.cantHorasConsultadas - 1
                    ? prevState.iFecha + 1
                    : 0;
            return { iFecha: newiFecha };
        });
    }

    onDateTimeChange(e) {
        this.setState({ iFecha: e });
    }

    onVarChange(idVariable) {
        if (idVariable > 0) {
            let cantFechasVar =
                this.state.datosVars.getCantIFechasDeVar(idVariable);
            let iFecha = this.state.iFecha;
            if (cantFechasVar !== this.state.cantFechasVar)
                iFecha = cantFechasVar - 1;
            this.setState({
                idVariable,
                iFecha,
                cantFechasVar,
            });
        }
    }

    onStepBw() {
        this.setState((prevState) => {
            let newiFecha =
                prevState.iFecha > 0
                    ? prevState.iFecha - 1
                    : this.state.cantHorasConsultadas - 1;
            return { playing: false, iFecha: newiFecha };
        });
    }

    onPlay() {
        this.setState((prevState) => {
            if (!prevState.playing)
                intervalPlayId = setInterval(this.playDateTime, PLAY_TIME);
            else clearInterval(intervalPlayId);
            let newPlaying = !prevState.playing;
            return { playing: newPlaying };
        });
    }

    onStepFw() {
        this.setState((prevState) => {
            let newiFecha =
                prevState.iFecha < this.state.cantHorasConsultadas - 1
                    ? prevState.iFecha + 1
                    : 0;
            return { playing: false, iFecha: newiFecha };
        });
    }

    toggleTab(newTab) {
        this.setState((prevState) => {
            if (prevState.activeTab !== newTab) return { activeTab: newTab };
        });
    }

    setFiltroEstaciones(gerencias, automaticas, convencionales) {
        this.estacionesState.setFiltros(
            new FiltroEstaciones(gerencias, automaticas, convencionales)
        );
    }

    handleVisibilityChange() {
        console.log("cambio de visibilidad: " + document.hidden);
        this.setState({ isHidden: !document.hidden });
    }

    componentDidMount() {
        this.mounted = true;
        this.consultarDatos();

        setTimeout(() => {
            this.setState({ showingSplash: false });
        }, SPLASH_TIMEOUT);

        document.addEventListener(
            "visibilitychange",
            this.handleVisibilityChange
        );
    }

    componentWillUnmount() {
        this.mounted = false;
        if (intervalRefreshId) clearInterval(intervalRefreshId);
        document.removeEventListener(
            "visibilitychange",
            this.handleVisibilityChange
        );
    }

    render() {
        let styleMenuPanel = {
            float: "right",
            position: "relative",
            top: "60px",
            marginRight: "60px",
            zIndex: 3,
        };
        if (isMobile) {
            styleMenuPanel.marginRight = "0px";
            styleMenuPanel.marginLeft = "10px";
            styleMenuPanel.float = "left";
        }

        let styleImgSplash = {
            width: "40%",
            heigth: "40%",
            marginLeft: "0",
            marginRight: "0",
        };
        let splashStyle = {
            backgroundColor: Colors.primary,
            width: "100%",
            height: "100%",
        };

        if (this.state.showingSplash) {
            styleMenuPanel.display = "none";
        }
        let estaciones = this.estacionesState
            ? this.estacionesState.getOrdenadasFiltradas()
            : null;
        let urlAssets = TEST_ASSETS_URL;
        if (!TEST) {
            urlAssets = PROD_ASSETS_URL;
        }

        let disclaimer = (
            <ul>
                <li key={1} className="mt-2">
                    <strong>
                        Estaciones Meteorológicas Convencionales (círculos
                        bordes continuo)
                    </strong>
                    <ul>
                        <li className="mt-1" key={1}>
                            Cuenta con personal operativo
                        </li>
                        <li className="mt-1" key={2}>
                            Se visualizan datos en el panel a cada 60 min
                        </li>
                    </ul>
                </li>
                <li key={2} className="mt-2">
                    <strong>
                        Estaciones Meteorológicas Automáticas (círculos bordes
                        discontinuo)
                    </strong>
                    <ul>
                        <li className="mt-1" key={1}>
                            Reportan en forma automática
                        </li>
                        <li className="mt-1" key={2}>
                            Se visualizan datos en el panel a cada 60 min
                        </li>
                    </ul>
                </li>
                <li key={3} className="mt-2">
                    <strong>Observaciones</strong>
                    <ul>
                        <li className="mt-1" key={1}>
                            Los datos presentados sin control de calidad
                        </li>
                        <li className="mt-1" key={2}>
                            Las estaciones en territorio uruguayo, pertenecen a
                            INUMET
                        </li>
                        <li className="mt-1" key={3}>
                            Las estaciones en territorio brasileño, pertenecen a
                            INMET
                        </li>
                        <li className="mt-1" key={4}>
                            Viento medido a 10 metros de altura
                        </li>
                    </ul>
                </li>
            </ul>
        );

        let opcionesVarsRB = this.radioItemsVars ? (
            <RadioGroup radioItemsData={this.radioItemsVars} />
        ) : null;
        return (
            <div
                className="overflow-hidden"
                style={{ width: "100%", height: "100%", overflow: "hidden" }}
            >
                {!this.isHidden && this.state.showingSplash && (
                    <Container style={splashStyle} fluid className="">
                        <Row className="justify-content-center align-items-center h-100">
                            <Col className="text-center" md={isMobile ? 12 : 6}>
                                <img
                                    className="mb-5"
                                    style={styleImgSplash}
                                    src={urlAssets + "splash_screen_land.png"}
                                ></img>
                                <p
                                    className="h1 mb-5"
                                    style={{ color: "white" }}
                                >
                                    Panel de visualización de datos
                                    meteorológicos
                                </p>
                                <p
                                    className="h1 mb-5"
                                    style={{ color: "white" }}
                                >
                                    Bienvenidos
                                </p>
                                <Spinner
                                    as="span"
                                    color="white"
                                    animation="border"
                                    size="xl"
                                    role="status"
                                    aria-hidden="true"
                                    variant="light"
                                />
                            </Col>
                        </Row>
                    </Container>
                )}
                <SpinnerFechasDatosVars
                    iFecha={this.state.iFecha}
                    loading={this.state.loading}
                    datosVars={this.state.datosVars}
                    idVariable={this.state.idVariable}
                    playTime={700}
                    cantFechasVar={this.state.cantFechasVar}
                    onIFechaChange={this.onIFechaChange}
                    show={!this.state.showingSplash}
                    formatoFecha={DATE_TIME_LATIN_FORMAT}
                />
                {VERSION === 2 && (
                    <React.Fragment>
                        <input
                            id="slide-menu-right"
                            className="menu-toggle"
                            type="checkbox"
                        />
                        <div className="menu-wrap shadow-lg">
                            <div style={{ backgroundColor: Colors.primary }}>
                                <div style={{ float: "right" }}>
                                    <ImgButton
                                        iconId="times-circle"
                                        text="Ocultar Menú"
                                        fas
                                        onClick={() => {
                                            if (
                                                this.botonMenuOpcionesRef &&
                                                this.botonMenuOpcionesRef
                                                    .current
                                            )
                                                this.botonMenuOpcionesRef.current.click();
                                        }}
                                    />
                                </div>
                                <Logo
                                    logoConFondoIcono
                                    pathPrefix={urlAssets}
                                    width={200}
                                    padding={20}
                                />
                                <div className="h3 sub-title ml-4">
                                    Panel visualización de datos meteorológicos
                                </div>
                            </div>
                            <div className="menu-content">
                                <div className="form-group row mb-2 ml-4">
                                    <div className="col-md-12 mt-4">
                                        {opcionesVarsRB}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <label
                            htmlFor="slide-menu-right"
                            className="menu-overlay"
                        ></label>
                    </React.Fragment>
                )}

                {VERSION === 2 && (
                    <React.Fragment>
                        <input
                            id="slide-menu-referencias"
                            className="menu-toggle"
                            type="checkbox"
                        />
                        <div className="menu-wrap-refs shadow-lg">
                            <div style={{ backgroundColor: Colors.primary }}>
                                <div style={{ float: "right" }}>
                                    <ImgButton
                                        iconId="times-circle"
                                        text="Ocultar Refs"
                                        fas
                                        onClick={() => {
                                            if (
                                                this.botonReferenciasRef &&
                                                this.botonReferenciasRef.current
                                            )
                                                this.botonReferenciasRef.current.click();
                                        }}
                                    />
                                </div>
                                <Logo
                                    logoConFondoIcono
                                    pathPrefix={urlAssets}
                                    width={200}
                                    padding={20}
                                />
                                <div className="h3 sub-title ml-4">
                                    Referencias
                                </div>
                            </div>
                            <div className="mt-4 mb-4 menu-content">
                                <div className="ml-2 mr-2">{disclaimer}</div>
                            </div>
                        </div>
                        <label
                            htmlFor="slide-menu-referencias"
                            className="menu-overlay"
                        ></label>
                    </React.Fragment>
                )}

                {VERSION === 2 && (
                    <label
                        id={"botonMenuOpciones"}
                        ref={this.botonMenuOpcionesRef}
                        htmlFor="slide-menu-right"
                        className="map-button menu-button shadow-lg"
                    >
                        <FAIcon mr={2} fas iconId="bars" color="#67b5d1" />
                        OPCIONES
                    </label>
                )}
                {VERSION === 2 && !this.state.showingSplash && (
                    <label
                        id={"botonReferencias"}
                        htmlFor="slide-menu-referencias"
                        ref={this.botonReferenciasRef}
                        className="map-button button-referencias shadow-lg"
                    >
                        <FAIcon
                            mr={2}
                            fas
                            iconId="info-circle"
                            color="#67b5d1"
                        />
                        Referencias
                    </label>
                )}

                {VERSION === 2 && (
                    <a className="" href="https://www.inumet.gub.uy">
                        <div className="logo-flotante shadow p-2">
                            <Logo
                                pathPrefix={urlAssets}
                                width={100}
                                padding={1}
                            />
                            <p style={{ fontSize: "10px" }} className="ml-2">
                                Volver a portada
                            </p>
                        </div>
                    </a>
                )}
                <div
                    style={{
                        height: "90%",
                        width: "100%",
                    }}
                >
                    {!this.state.showingSplash && (
                        <MapaDatosVars
                            datosVars={this.state.datosVars}
                            escalas={getEscalasVars(IDS_VARS_ESCALAS)}
                            idVariable={this.state.idVariable}
                            estaciones={estaciones}
                            idVarGrafica={MetConstants.VAR_ID_TEMPAIRE_1H_INST}
                            centroMapaInicial={this.state.centroMapaInicial}
                            iFecha={this.state.iFecha}
                            idsVariablesEnFichaEstacion={
                                IDS_VARS_FICHAS_ESTACIONES
                            }
                            idsVariablesTooltip={IDS_VARS_ESCALAS}
                            graficasVariablesCombinadas={
                                this.graficasVariablesCombinadas
                            }
                            opcionesVars={varsOpciones}
                        />
                    )}
                </div>
            </div>
        );
    }

    getLabelVar(v) {
        return varsOpciones[v.id];
    }

    consultarDatos() {
        let urlDatos = TEST_URL_DATOS;
        if (!TEST) {
            urlDatos = PROD_URL_DATOS;
        }
        axios
            .get(urlDatos)
            .then((response) => {
                this.setState({ loading: true });
                let datosVarsUI = new DatosVarsUI();
                datosVarsUI.setDirVientoComoPtosCardinales(true);
                datosVarsUI.setDirVientoComoPtosCardinales(true);
                //datosVarsUI.setCalcUnidad(MetConstants.VAR_ID_INTVIENTO_1H_INST,(val)=>{return val*1.852});
                //datosVarsUI.setCalcUnidad(MetConstants.VAR_ID_INTRAFAGA_1H_INST,(val)=>{return val*1.852});

                datosVarsUI.setCantDecimalesVars(MetConstants.idsIntViento, 0);
                datosVarsUI.setCantDecimalesVars(MetConstants.idsPresAtm, 1);
                datosVarsUI.setCantDecimalesVars(MetConstants.idsPrecip, 1);
                let datosVars = new DatosVars(response.data, datosVarsUI);
                this.estacionesState = crearEstacionesState(
                    datosVars.estaciones,
                    this.state.gerencias,
                    this.state.automaticas,
                    this.state.convencionales
                );
                this.estacionesState.setOrden(
                    new OrdenEstaciones(
                        TIPO_ORDEN_ESTACIONES_GERENCIA_TIPOESTACION_NOMBRE,
                        null,
                        [
                            MetConstants.gerencias.inmet,
                            MetConstants.gerencias.inia,
                            MetConstants.gerencias.inumet,
                        ]
                    )
                );
                datosVars.estaciones.forEach((e) => {
                    e.nombre = e.nombre.replace("G3", "");
                });
                this.radioItemsVars = [];
                datosVars.variables.forEach((v) => {
                    let varOpciones = this.getLabelVar(v);
                    if (varOpciones) {
                        this.radioItemsVars[varOpciones.order] =
                            new RadioItemData(
                                v.id,
                                v.id === MetConstants.VAR_ID_TEMPAIRE_1H_INST,
                                () => {
                                    this.onVarChange(v.id);
                                    if (
                                        isMobile &&
                                        this.botonMenuOpcionesRef &&
                                        this.botonMenuOpcionesRef.current
                                    )
                                        this.botonMenuOpcionesRef.current.click();
                                },
                                varOpciones.label,
                                varOpciones.sublabel
                            );
                    }
                });
                let cantFechasVar = datosVars.getCantIFechasDeVar(
                    this.state.idVariable
                );
                let iFecha = cantFechasVar - 1;
                this.setState({
                    loading: false,
                    datosVars,
                    cantFechasVar,
                    iFecha,
                    estaciones: datosVars.estaciones,
                    cantHorasConsultadas: datosVars.fechas.length,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }
}

export { MonitoreoDatosVarsMapa as default };
